module.exports = "/virtual-football-league/img/header-babaijebu.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/header-babaijebu.png
// module id = 330
// module chunks = 4